import { GetPurchaseReadyItemsState } from './getPurchaseReadyItems.types'

const initialState: GetPurchaseReadyItemsState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
